import {useTranslation} from "react-i18next";
import {useMemo} from "react";
import * as yup from "yup";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";

export const useGuardianAddressForm = (data, showAddressForm) => {
    const {t} = useTranslation();

    const defaultValues = useMemo(() => ({
        relationshipTypeId: data?.relationshipTypeId || "",
        addressLine1: data?.address?.addressLine1 || "",
        addressLine2: data?.address?.addressLine2 || "",
        city: data?.address?.city || "",
        area: data?.address?.area || "",
        code: data?.address?.code || "",
        country: data?.address?.country || "",
        responsibleGuardianTitle: data?.responsibleGuardian?.title || "",
        responsibleGuardianForename: data?.responsibleGuardian?.forename || "",
        responsibleGuardianSurname: data?.responsibleGuardian?.surname || "",
        responsibleGuardianEmail: data?.responsibleGuardian?.email || "",
        responsibleGuardianPhone: data?.responsibleGuardian?.phone || "",
        responsibleGuardianRelationshipId: data?.responsibleGuardian?.relationshipTypeId || "",
    }), [data]);

    const schema = useMemo(() => yup.object().shape({
        relationshipTypeId: yup.string().required(t("validation.required")),
        country: yup.string().required(t("validation.required")),
        addressLine1: yup.string().required(t("validation.required")),
        addressLine2: yup.string(),
        city: yup.string().required(t("validation.required")),
        area: yup.string().required(t("validation.required")),
        code: yup.string().required(t("validation.required")),
        responsibleGuardianTitle: yup.string().when("relation", {
            is: (val) => showAddressForm,
            then: (schema) => schema.required(t("validation.required")),
            otherwise: (schema) => schema.notRequired(),
        }),
        responsibleGuardianForename: yup.string().when("relation", {
            is: (val) => showAddressForm,
            then: (schema) => schema.required(t("validation.required")),
            otherwise: (schema) => schema.notRequired(),
        }),
        responsibleGuardianSurname: yup.string().when("relation", {
            is: (val) => showAddressForm,
            then: (schema) => schema.required(t("validation.required")),
            otherwise: (schema) => schema.notRequired(),
        }),
        responsibleGuardianEmail: yup.string().when("relation", {
            is: (val) => showAddressForm,
            then: (schema) => schema.email(t("validation.emailInvalid")).required(t("validation.required")),
            otherwise: (schema) => schema.notRequired(),
        }),
        responsibleGuardianPhone: yup.string().when("relation", {
            is: (val) => showAddressForm,
            then: (schema) => schema.required(t("validation.required")),
            otherwise: (schema) => schema.notRequired(),
        }),
        responsibleGuardianRelationshipId: yup.string().when("relation", {
            is: (val) => showAddressForm,
            then: (schema) => schema.required(t("validation.required")),
            otherwise: (schema) => schema.notRequired(),
        }),
    }), [showAddressForm, t]);

    const {
        control,
        handleSubmit,
        watch,
        formState: {errors, isValid, isDirty},
        setValue,
    } = useForm({
        resolver: yupResolver(schema),
        defaultValues,
    });

    return {
        handleSubmit,
        control,
        errors,
        isValid,
        watch,
        isDirty,
        setValue,
    };
};
